export default function WebApp() {
  return (
    <section id="webapp" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-device-line"></i> 双端畅享
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
            网页版与 APP，随你选择
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            电脑追番用网页版，随时随地用 APP。两种方式互为补充，动漫之家内容同步、收藏漫游，
            换设备也能无缝续看。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <article className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100">
            <div className="relative h-52 w-full overflow-hidden md:h-60">
              <img
                src="https://readdy.ai/api/search-image?query=cheerful%20anime%20girl%20character%20watching%20animated%20shows%20on%20a%20laptop%2C%20cozy%20bedroom%20with%20warm%20orange%20fairy%20lights%2C%20manga%20books%20and%20figurines%20on%20desk%2C%20soft%20coral%20and%20teal%20color%20palette%2C%20flat%20clean%20illustration%2C%20playful%20youthful%20energy&width=800&height=600&seq=anime-web-01&orientation=landscape"
                alt="动漫之家网页版追番场景插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-computer-line text-base"></i>
                </span>
                <h3 className="text-lg font-bold text-foreground-950">动漫之家网页版</h3>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                打开官网即可在线观看，支持番剧、漫画、资讯等全站内容。无需下载安装，
                大屏追番更沉浸，进度实时云同步，换设备也不丢记录。
              </p>
              <ul className="mt-4 space-y-2">
                {["免安装，浏览器即开即用", "番剧漫画资讯一站聚合", "观看进度自动云同步"].map((t) => (
                  <li key={t} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                    {t}
                  </li>
                ))}
              </ul>
              <a
                href="#access"
                className="mt-6 inline-flex w-fit whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-arrow-right-up-line mr-1"></i>进入网页版
              </a>
            </div>
          </article>

          <article className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100">
            <div className="relative h-52 w-full overflow-hidden md:h-60">
              <img
                src="https://readdy.ai/api/search-image?query=anime%20smartphone%20app%20mockup%20with%20colorful%20manga%20and%20animated%20show%20thumbnails%20on%20screen%2C%20floating%20play%20buttons%20and%20heart%20icons%20around%2C%20soft%20pink%20and%20coral%20background%2C%20clean%20flat%20illustration%2C%20modern%20youthful%20design&width=800&height=600&seq=anime-app-01&orientation=landscape"
                alt="动漫之家APP下载界面插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-smartphone-line text-base"></i>
                </span>
                <h3 className="text-lg font-bold text-foreground-950">动漫之家 APP</h3>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                随时随地追番追漫，支持离线缓存、弹幕互动、追更提醒。通勤路上、睡前时光，
                动漫之家 APP 让快乐随身相伴。
              </p>
              <ul className="mt-4 space-y-2">
                {["支持离线缓存，断网也能看", "弹幕互动，追番不孤单", "追更订阅，新番更新不错过"].map((t) => (
                  <li key={t} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                    {t}
                  </li>
                ))}
              </ul>
              <a
                href="#download"
                className="mt-6 inline-flex w-fit whitespace-nowrap rounded-full bg-accent-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-download-2-line mr-1"></i>下载 APP
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}